import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import AccountMenu from '../../Modules/AccountMenu'
import IncompanyKennisNew from '../../Modules/Kennis/Toevoegen/IncompanyKennisNew'

import RefferalSearchIncompanyKennis from '../../Modules/Kennis/Toevoegen/RefferalSearchIncompanyKennis'
import RegularSearchIncompanyKennis from '../../Modules/Kennis/Toevoegen/RegularSearchIncompanyKennis'

class MemberKennisOverdrachtAdd extends Component {
  render() {
    return (
      <div className="route">
        <AccountMenu />
        <div className="grey-bg">
          <h1 className="pageTitle">
            Een incompany kennisoverdracht toevoegen
            </h1>
          <p>Op deze webpagina kunt u uw permanente educatie activiteiten invullen.</p>
          <p>Bij bekende opleidingen en cursussen kunt u selecteren uit het opleidingen- en cursussenbestand van het Constructeursregister. U krijgt dan direct het aantal kenniseenheden te zien. Definitieve toewijzing van de kenniseenheden vindt plaats na beoordeling door de toetsingscommissie. Klik hier voor de toelichting..</p>
          <Row>
            <Col mdPush={2} md={8}>
              <IncompanyKennisNew /><br /><br />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default MemberKennisOverdrachtAdd;



// WEBPACK FOOTER //
// ./src/components/Member/Pages/Toevoegen/IncompanyKennisoverdracht.js